import { render, staticRenderFns } from "./MultiItemSelector.vue?vue&type=template&id=c49f9626&scoped=true&lang=pug"
import script from "./MultiItemSelector.vue?vue&type=script&lang=js"
export * from "./MultiItemSelector.vue?vue&type=script&lang=js"
import style0 from "./MultiItemSelector.vue?vue&type=style&index=0&id=c49f9626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49f9626",
  null
  
)

export default component.exports